import AmendGoodPractice from "./components/AmendGoodPracticeForm";

export default AmendGoodPractice